import React from 'react';
import { Button, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import TermTypesDropdownList from './TermTypesDropdownList';
import YearsDropdownList from './YearsDropdownList';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { defaultStaticRanges, defaultInputRanges } from 'react-date-range/dist/defaultRanges';

export const DateRangePickerMode = {
	TERM: 'term',
	PERIOD: 'period'
};

const DateRangePopover = ({ className, buttonClassName, style, ranges, onPeriodChange, onModeChange,
	term, onTermSelect, year, onYearSelect, onApply, onCancel, mode, locale, t }) => {

	const localizedStaticRanges = defaultStaticRanges.map(range => ({
		...range,
		label: t(`DateRangePicker_StaticRanges_${range.label.replace(/\s+/g, '')}`)	// use current label text without the spaces to find the resource string
	}));

	const localizedInputRanges = defaultInputRanges.map(range => ({
		...range,
		label: t(`DateRangePicker_InputRanges_${range.label.replace(/\s+/g, '')}`)
	}));

	return <div
		className={className}
		style={{
			...style,
			position: 'absolute',
			zIndex: 2000,
			backgroundColor: '#FFF',
			boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
			border: '1px solid #CCC',
			borderRadius: 4,
			marginTop: 5,
			padding: 5,
			maxWidth: 600
		}}>
		<div>
			<div>
				<ToggleButtonGroup type='radio' name='mode' value={mode} onChange={onModeChange} justified>
					<ToggleButton value={DateRangePickerMode.TERM} className={mode === DateRangePickerMode.TERM ? 'btn-light-grey' : ''}>{t('SalesDashboard_SchoolYearOrTerm')}</ToggleButton>
					<ToggleButton value={DateRangePickerMode.PERIOD} className={mode === DateRangePickerMode.PERIOD ? 'btn-light-grey' : ''}>{t('SalesDashboard_DateRange')}</ToggleButton>
				</ToggleButtonGroup>
				<div className='clearfix' />

			</div>

			{mode === DateRangePickerMode.PERIOD && <DateRangePicker ranges={ranges} onChange={onPeriodChange} locale={locale} staticRanges={localizedStaticRanges} inputRanges={localizedInputRanges} />}

			{mode === DateRangePickerMode.TERM &&
				<ButtonToolbar style={{ marginTop: '5px' }}>
				<YearsDropdownList render='button' style={{ marginRight: '5px' }} className={buttonClassName} value={year} onChange={onYearSelect} hideEmptyOption={true} />
				<TermTypesDropdownList render='button' className={buttonClassName} value={term} onChange={onTermSelect} emptyLabel={t('Common_AllTerms')} />
				</ButtonToolbar>
			}
			<div className='clearfix' />
			<ButtonToolbar className='pull-right' style={{ marginTop: '5px' }}>
				<Button bsStyle='primary' onClick={onApply}>{t('DashboardFilter_Apply')}</Button>
				<Button bsStyle='default' onClick={onCancel} style={{ marginLeft: '5px' }}>{t('DashboardFilter_Cancel')}</Button>
			</ButtonToolbar>
		</div>
	</div>;
};

export default DateRangePopover;